import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { update } from 'actions/data'
import Tooltip from 'components/theme/HelpTooltip'

const updatePreferences = (payload) => (dispatch, getState) => {
	const preferencesAndAccountID = getState().AccountSettings.preferences
	const preferences = preferencesAndAccountID?.preferences
	const account_id = preferencesAndAccountID?.account_id

	dispatch(
		update(
			{
				account_id,
				preferences: { ...preferences, ...payload },
			},
			'account/preference',
			'',
			'account/preference',
			'none',
		),
	)
}

const RoundRobin = ({
  updatePreferences,
  delete_contacts,
  update_contacts,
  read_contacts,
  deduplicate_contacts,
}) => (
  <div>
    <h1 style={{ textAlign: 'center' }}>CONTACT SETTINGS</h1>
    <Grid container spacing={24}>
      <Grid item sm={12} md={12} lg={12} xl={4}>
        <Typography variant="h5" gutterBottom>
          Who should be able to delete contacts?
        </Typography>
        <select
          style={{
            width: '90%',
            height: 45,
            padding: 5,
            borderRadius: 25,
            fontSize: 16,
          }}
          value={delete_contacts}
          onChange={e =>
            updatePreferences({ delete_contacts: e?.target?.value })
          }
        >
          <option value="anybody">Anybody</option>
          <option value="accountowner">Account Owner</option>
          <option value="contactowner">Contact Owner</option>
        </select>
      </Grid>
      <Grid item sm={12} md={12} lg={12} xl={4}>
        <Typography variant="h5" gutterBottom>
          Who should be able to update/edit contacts?
        </Typography>
        <select
          style={{
            width: '90%',
            height: 45,
            padding: 5,
            borderRadius: 25,
            fontSize: 16,
          }}
          value={update_contacts}
          onChange={e =>
            updatePreferences({ update_contacts: e?.target?.value })
          }
        >
          <option value="anybody">Anybody</option>
          <option value="accountowner">Account Owner</option>
          <option value="contactowner">Contact Owner</option>
        </select>
      </Grid>
      <Grid item sm={12} md={12} lg={12} xl={4}>
        <Typography variant="h5" gutterBottom>
          Who should be able to view contacts?
        </Typography>
        <select
          style={{
            width: '90%',
            height: 45,
            padding: 5,
            borderRadius: 25,
            fontSize: 16,
          }}
          value={read_contacts}
          onChange={e => updatePreferences({ read_contacts: e?.target?.value })}
        >
          <option value="anybody">Anybody</option>
          <option value="contactowner">Contact Owner AND Account Owner</option>
        </select>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" gutterBottom>
          How should duplicate contacts be handled?
        </Typography>
        <select
          style={{
            width: '90%',
            height: 45,
            padding: 5,
            borderRadius: 25,
            fontSize: 16,
          }}
          value={deduplicate_contacts}
          onChange={e =>
            updatePreferences({
              deduplicate_contacts: e?.target?.value,
            })
          }
        >
          <option value="first_last_contact_methods">
            First name, last name, and contact methods
          </option>
          <option value="contact_methods">Only contact methods</option>
        </select>
        <Tooltip iconStyle={{ verticalAlign: 'middle', marginLeft: 10 }}>
          <span>
            "<strong>First name, last name, and contact methods</strong>" is the
            default setting. This means that when a user tries to create a new
            contact, the system will look for other contacts with the same
            emails or phone numbers, and then compare first name and last name.
            If there isn't an exact match on first name and last name, then a
            duplicate contact is added. "<strong>Only contact methods</strong>"
            means that when a user tries to create a new contact, the system
            will only look for other contacts with the same emails or phone
            numbers. If a match is found, then that duplicate contact is updated
            with any new information provided.
          </span>
        </Tooltip>
        {/* <span
					style={{
						display: 'inline-block',
						verticalAlign: 'bottom',
						marginRight: 20,
						position: 'relative',
					}}
				>
					<div style={{ marginBottom: 10 }}>
						<Switch
							checked={deduplicate_contacts === 'first_last_contact_methods'}
							onChange={(e) =>
								updatePreferences({
									deduplicate_contacts: e?.target?.checked
										? 'first_last_contact_methods'
										: 'contact_methods',
								})
							}
							value="checkedB"
							color="secondary"
						/>
					</div>
					<div
						style={{
							position: 'absolute',
							bottom: 0,
							left: '50%',
							transform: 'translate(-50%, 0)',
							color:
								deduplicate_contacts === 'first_last_contact_methods'
									? 'green'
									: 'red',
						}}
					>
						{deduplicate_contacts === 'first_last_contact_methods'
							? 'Enabled'
							: 'Disabled'}
					</div>
				</span>
				<span style={{ display: 'inline-block' }}>
					<div style={{ fontWeight: 'bold' }}>Enable duplicate contacts</div>
					<div>
						Enabling duplicate contacts will insert a new contact instead of
						updating an existing contact unless there is at least one matching
						contact method and both first and last names match case
						insensitively.
					</div>
				</span> */}
      </Grid>
    </Grid>
  </div>
)

export default connect(
	(state) => ({
		delete_contacts:
			state?.AccountSettings?.preferences?.preferences?.delete_contacts ||
			'anybody',
		update_contacts:
			state?.AccountSettings?.preferences?.preferences?.update_contacts ||
			'anybody',
		read_contacts:
			state?.AccountSettings?.preferences?.preferences?.read_contacts ||
			'anybody',
		deduplicate_contacts:
			state?.AccountSettings?.preferences?.preferences?.deduplicate_contacts ||
			'first_last_contact_methods',
	}),
	(dispatch) => bindActionCreators({ updatePreferences }, dispatch),
)(RoundRobin)
